<template>
	<div class="page_content explore_entity_inside program" aria-label="program guide jobs">

		<div class="row page-heading">
      		<div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 input module_heading">
        		<span class="module_icon icon-list"></span>
        		<label v-if="formattedProgramGuide && formattedProgramGuide.title" id="programGuideTitle" class="head_txt module_type_name">
          			Program: {{formattedProgramGuide.title}}
        		</label>
        		<label v-else id="programGuideTitle" class="head_txt module_type_name">Program: {{formattedCareer.name}}</label>
      		</div>

      		<div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 btn_container">
        		<b-btn @click.stop.prevent="returnToClicked" :aria-label="deCamelCase()">
              <span class="btn_ic ic-back"></span>
              <span class="btn_txt"> {{ deCamelCase() }} </span>
            </b-btn>
            <span v-if="showAddCompletedCoursesOnResult">
              <b-button @click="addCompletedCourses" aria-label="add completed courses">Add Completed Courses</b-button>
            </span>
      		</div>
    	</div>


		<div class="page_content_container">

    		<div v-if="formattedProgramGuide && formattedProgramGuide.title">
      			<program-guide-menu
          			:cipCode="formattedProgramGuide.cipCode"
          			:programGuideCode="formattedProgramGuide.code"
          			:type="formattedProgramGuide.type"
          			:returnTo="returnTo"
          			:active="'jobs'">
      			</program-guide-menu>
    		</div>

    		<div class="pg_content">

    			<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">

					<div class="row pg_sec">

	        			<div class="col-12 hd ace_sec_hd" aria-label="Jobs">
		          			<h2>Jobs</h2>
		          			<span class="hd_bdr"></span>
		          		</div>

	         			<div class="col-12 sec_content">

							<b-jumbotron>
	            				<h4 class="text-center ace_sec_txt">Jobs View is currently not available.</h4>
	            				<p class="text-center ace_sec_txt">Please reach out to your institutional admin to unlock the Jobs View.</p>
	          				</b-jumbotron>

			  			</div>

		          	</div> <!-- .pg_sec -->

	          	</div>

        	</div> <!-- .pg_content -->

		</div> <!-- .page_content_container -->


		<div class="loading-spinner">
      		<b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        		<div class="text-center" style="color: #FFF">
          			<i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
        		</div>
      		</b-modal>
    	</div>


	</div>
</template>


<script>
import { mapState, mapActions } from 'vuex'
import { PackageUtil } from '../../../package_utils'
import ProgramGuideMenu from './ProgramGuideMenu'
import ProgramGuideSummary from './ProgramGuideSummary'

export default {
  name: 'program-guide-jobs',
  props: ['cipCode', 'programGuideCode', 'type', 'returnTo', 'loadDataFromServer'],
  components: {
    ProgramGuideMenu,
    ProgramGuideSummary
  },
  data: () => {
    return {
      DEFAULT_TYPE: 'MAJOR',
      DEFAULT_RETURN_TO: 'exploreIntro',
      EXPLORE_RESULTS: 'exploreProgramGuideResults'
    }
  },

  async mounted () {
    this.loadDataForProgramGuideJobs()
  },

  methods: {
    ...mapActions([
      'loadProgramGuide',
      'loadProgramGuideCareers'
    ]),
    addCompletedCourses () {
      return this.$router.push({name: 'selfReportedCourseList'})
    },
    async loadDataForProgramGuideJobs () {
      let cipCode = this.cipCode
      let programGuideCode = this.programGuideCode
      let returnTo = this.returnTo && this.returnTo.length ? this.returnTo : this.DEFAULT_RETURN_TO
      if (!cipCode || !programGuideCode) {
        return this.$router.push({ name: returnTo })
      }
      let programGuide = await this.loadProgramGuide({
        cipCode: cipCode,
        programGuideCode: programGuideCode,
        type: this.programGuideType,
        loadDataFromServer: true
      })
      if (!programGuide || !programGuide.cipCode) {
        return this.$router.push({ name: returnTo })
      }
      // load related career information, if any exists
      await this.loadProgramGuideCareers({ cipCode: programGuide.cipCode, code: programGuide.code, showAllOccupations: true })
    },
    returnToClicked () {
      return this.$router.push({ name: this.returnTo })
    },
    deCamelCase () {
      if (!this.returnTo) {
        this.returnTo = this.DEFAULT_RETURN_TO
      }
      if (this.returnTo === this.EXPLORE_RESULTS) {
        return 'return to all results'
      }
      let result = this.returnTo.replace(/([A-Z])/g, ' $1')
      return result
    },
    getCoursePlanningPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getCoursePlanningPackage(packages)
    }
  },
  computed: {
    ...mapState({
      'programGuide': state => state.programguide.programGuideObject,
      'careersObject': state => state.programguide.careers,
      'careerResult': state => state.programguide.careerResult,
      'packages': state => state.institution.packages
    }),
    formattedProgramGuide () {
      let formattedProgramGuide = this.programGuide
      return formattedProgramGuide
    },
    formattedCareers () {
      let careers = this.careersObject
      let formattedCareers = []
      if (!careers || !careers.targetOccupations || !careers.targetOccupations.length || !careers.targetOccupations.length === 0) {
        return formattedCareers
      }
      careers.targetOccupations.forEach((career) => {
        formattedCareers.push(JSON.parse(career))
      })
      return formattedCareers
    },
    formattedCareer () {
      let formattedCareer = (this.careerResult && this.careerResult.uuid) ? this.careerResult : this.careersObject
      if (!formattedCareer || !formattedCareer.uuid) {
        return {}
      }
      return formattedCareer
    },
    programGuideType () {
      let programGuideType = this.type
      if (!programGuideType || !programGuideType.length || programGuideType.length <= 0) {
        programGuideType = this.DEFAULT_TYPE
      }
      return programGuideType
    },
    showAddCompletedCoursesOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultAddCompletedCourses) {
        return false
      }
      return exploreProgramsFlagMap.searchResultAddCompletedCourses.enabled
    }
  },
  watch: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideJobs.vue